import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Currency from 'Components/Format/Currency';
import { lifeInsurancePolicies as enumeratedValuesLifeInsurancePolicies } from 'Consts/EnumeratedValues';
import Short from 'Components/Format/DateFormat/Short';
import ShadowBox from 'Components/UI/ShadowBox';
import AccountsHeading from '../Accounts/Heading';
import AccountsTable from '../Accounts/Table';
import AccountsTableInner from '../Accounts/TableInner';
import '../Accounts/index.css';

const LifeInsurance = ({
  lifeInsuranceAccounts,
  groupLifeInsuranceAccounts,
  editLink,
}) => (
  <div className="life-insurance">
    {(lifeInsuranceAccounts.length > 0
      || groupLifeInsuranceAccounts.length > 0) && (
      <Fragment>
        <AccountsHeading
          title="Life Insurance"
          editLink={editLink}
          editTooltip="Edit Life Insurance"
        >
          <AccountsTable className="accounts-life-insurance">
            <tr className="headings">
              <td className="coverage">Coverage</td>
              <td className="type">Type</td>
              <td className="company">Company</td>
              <td className="inception-date">Inception Date</td>
              <td className="insured">Insured</td>
              <td className="notes">Notes</td>
              <td className="length-of-coverage">Length Of Coverage</td>
            </tr>
          </AccountsTable>
        </AccountsHeading>
        <AccountsTableInner>
          <ShadowBox>
            <AccountsTable className="accounts-life-insurance">
              {/*
                |--------------------------------------------------------------------------
                | Life Insurance
                |--------------------------------------------------------------------------
                */}
              {groupLifeInsuranceAccounts.length > 0 && (
                <Fragment>
                  {groupLifeInsuranceAccounts.map(account => (
                    <tr key={`${account.attributes.id}glip`} className="data">
                      <td className="coverage">
                        {account.attributes.coverage !== null && (
                          <Currency amount={account.attributes.coverage} />
                        )}
                      </td>
                      <td className="type">Group Life</td>
                      <td className="company">{account.attributes.company}</td>
                      <td className="inception-date">&nbsp;</td>
                      <td className="insured">{account.attributes.insuredClientName}</td>
                      <td className="notes">{account.attributes.notes}</td>
                      <td className="length-of-coverage">{account.attributes.length}</td>
                    </tr>
                  ))}
                </Fragment>
              )}
              {lifeInsuranceAccounts.length > 0 && (
                <Fragment>
                  {lifeInsuranceAccounts.map(account => (
                    <tr key={`${account.id}lip`} className="data">
                      <td className="coverage">
                        {account.attributes.coverage !== null && (
                          <Currency amount={account.attributes.coverage} />
                        )}
                      </td>
                      <td className="type">
                        {enumeratedValuesLifeInsurancePolicies(
                          'type',
                          account.attributes.type,
                        )}
                      </td>
                      <td className="company">{account.attributes.company}</td>
                      <td className="inception-date">
                        <Short date={account.attributes.inception} />
                      </td>
                      <td className="insured">{account.attributes.insuredClientName}</td>
                      <td className="notes">{account.attributes.notes}</td>
                      <td className="length-of-coverage">{account.attributes.length}</td>
                    </tr>
                  ))}
                </Fragment>
              )}
            </AccountsTable>
          </ShadowBox>
        </AccountsTableInner>
      </Fragment>
    )}
  </div>
);

LifeInsurance.propTypes = {
  lifeInsuranceAccounts: PropTypes.array.isRequired,
  groupLifeInsuranceAccounts: PropTypes.array.isRequired,
  editLink: PropTypes.string,
};
LifeInsurance.defaultProps = {
  editLink: '',
};

export default LifeInsurance;
